var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 259,
    viewBox: "0 0 161 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4101 6.2305H6.18926V13.4513H0V0L13.4101 0.0412391V6.2305ZM0 44.8102H6.18926V64.4095H0V44.8102ZM6.18926 95.7684H0V115.368H6.18926V95.7684ZM0 197.685H6.18926V217.284H0V197.685ZM0 248.685H6.18926V259H0V248.685ZM6.18926 146.727H0V166.326H6.18926V146.727ZM45.4904 0.189387L45.4764 6.37863L65.5295 6.42413L65.5436 0.234886L45.4904 0.189387ZM97.6382 6.50093L97.6512 0.311683L117.704 0.353683L117.691 6.54293L97.6382 6.50093ZM149.739 0.278104L149.727 6.46735L160.042 6.48716L160.054 0.297908L149.739 0.278104ZM109.469 126.22H125.973V132.409H109.469V126.22ZM43.4495 126.22H26.9449V132.409H43.4495V126.22ZM68.2067 126.22H84.7114V132.409H68.2067V126.22Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperF);
export default __webpack_public_path__ + "static/media/UPPER_F.8fdca82aed2c2b263aabcc473b9b63d0.svg";
export { ForwardRef as ReactComponent };